
import React from "react";
import { NavLink } from "react-router-dom";

import { navItems } from "../../constants";

function Navebar({
  active,
  DropActive,
  language = "ar",
}) {
  const handleNavigate = () => {
    window.scrollTo(0, 0);
  };

  return (
    <nav
      aria-label={
        language === "ar"
          ? "التنقل الرئيسي"
          : "Main navigation"
      }
      className="
        hidden min-w-0
        items-center justify-center
        xl:flex
      "
    >
      <div
        className="
          flex items-center
          justify-center
          gap-1
          2xl:gap-2
        "
      >
        {navItems.map((item, index) => (
          <NavLink
            key={item.id ?? item.link ?? index}
            to={item.link}
            end={item.link === "/"}
            onClick={handleNavigate}
            className={({ isActive }) => {
              const selected =
                isActive ||
                active === index + 1;

              return `
                group relative
                inline-flex h-10
                shrink-0
                items-center justify-center
                whitespace-nowrap
                rounded-xl
                px-3
                transition-all duration-200
                2xl:px-4

                ${
                  selected
                    ? "bg-skin-soft/85 text-skin-heading"
                    : "text-skin-muted hover:bg-skin-soft/65 hover:text-skin-heading"
                }
              `;
            }}
          >
            {({ isActive }) => {
              const selected =
                isActive ||
                active === index + 1;

              return (
                <>
                  <span className="button-sm">
                    {language === "en"
                      ? item.titleEn
                      : item.titleAr}
                  </span>

                  {/* Active gold underline */}
                  <span
                    aria-hidden="true"
                    className={`
                      absolute bottom-1
                      left-1/2
                      h-[2px]
                      -translate-x-1/2
                      rounded-full
                      bg-skin-accent
                      transition-all duration-300

                      ${
                        selected
                          ? "w-6 opacity-100"
                          : "w-0 opacity-0 group-hover:w-5 group-hover:opacity-60"
                      }
                    `}
                  />
                </>
              );
            }}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default Navebar;
